import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkCard, UitkCardLink } from "@egds/react-core/cards";
import { UitkFigure } from "@egds/react-core/images";
import { UitkSheetTransition } from "@egds/react-core/sheet";
import { MapProps } from "./typings";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import FullScreenMap from "./FullScreenMap";
import { withStores } from "src/stores";
import { useDialog } from "@shared-ui/dialog-context";

const Map = withStores("analytics")((props: MapProps) => {
  const { analytics, staticMap, destination, pois, hotels, activities, context, maxWidthDialog, markers } = props;
  const { formatText } = useLocalization();
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog("destination-discovery-map");
  /* covered in e2e test */
  /* istanbul ignore next line */
  const toggleMapDialog = (toggleAction: string) => (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ): void => {
    e.preventDefault();
    const sidebarContainer = document.getElementsByClassName("dx-sidebar-content")[0];
    if (toggleAction === "open") {
      const flexTrackingInfo: FlexTrackingInfo = {
        moduleName: "TG.LP.Dest.Map.open",
        action: Action.CLICK,
      };
      sendDelayedTrackEvent(flexTrackingInfo, analytics);
      if (sidebarContainer) {
        sidebarContainer.classList.add("z-index-350");
      }
      dialogActions.openDialog();
    } else {
      // Event tracking is left out of the close toggle as it is handled in FullScreenMap.tsx.
      // This is to account for all the methods for exiting the map rather that just the toggle.
      if (sidebarContainer) {
        sidebarContainer.classList.remove("z-index-350");
      }
      dialogActions.closeDialog();
    }
  };

  return (
    <>
      <UitkCard overflow>
        <UitkFigure src={staticMap} />
        <UitkCardLink>
          <a href="#" onClick={toggleMapDialog("open")} data-testid="map-target">
            {formatText("destinationDiscoveryMap.button.open")}
          </a>
        </UitkCardLink>
      </UitkCard>
      <UitkSheetTransition isVisible={isDialogOpen}>
        <DialogComponent>
          <FullScreenMap
            context={context}
            destination={destination}
            pois={pois}
            hotels={hotels}
            activities={activities}
            markers={markers}
            toggleMapDialog={toggleMapDialog}
            maxWidthDialog={maxWidthDialog}
          />
        </DialogComponent>
      </UitkSheetTransition>
    </>
  );
});

export default Map;
